module.exports = __webpack_public_path__ + "img/NEF_SmartMeter.a37ab845.gif";